import React, { useState } from 'react';
import { View } from 'react-native-web';
import ColorBar from '../Colors/ColorBar';
import LinkTextButton from '../Buttons/LinkTextButton';
import { hashtag, reset_avatar_colors, Select_colors_applied } from '../../../utils/DictionaryManagementUtils';
import RegularText from '../Text/RegularText';

//= ========================================================================

const ContactListColors = ({
  globJSON,
  onConfigChanged,
  resetAvatarColors,
  colorList,
}) => {
  const { colors } = globJSON.configurations.theme;
  const isDeleteAllColors = () => {
    let counter = 0;
    colorList.forEach((colorId) => {
      if (globJSON.configurations.theme.colors[colorId] === hashtag) {
        counter += 1;
      }
    });
    return counter === 3;
  };
  const [deleteEnabled, setDeleteEnabled] = useState(!isDeleteAllColors());

  return (
    <View>
      <RegularText marginBottom={24}>{Select_colors_applied}</RegularText>
      <View style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 20,
        paddingEnd: 20,
      }}
      >
        {colorList.map((colorKey) => (
          <ColorBar
            globJSON={globJSON}
            updateColor={(colorId, newColor) => {
              colors[colorId] = newColor;
              setDeleteEnabled(!isDeleteAllColors());
              onConfigChanged();
            }}
            colorId={colorKey}
            avatarColor={deleteEnabled}
          />
        ))}
        <View style={{ justifyContent: 'end' }}>
          <LinkTextButton
            onPress={() => {
              resetAvatarColors();
              setDeleteEnabled(!isDeleteAllColors());
            }}
          >
            {reset_avatar_colors}
          </LinkTextButton>
        </View>
      </View>
    </View>
  );
};

export default ContactListColors;
